
import React, { useContext } from "react";
import ZeroImg from "./zero-img";
import { useNavigate } from "react-router-dom";
import { ErrorContext } from "./error-boundary";

const NotFound = () => {
    const {resetError} = useContext(ErrorContext);
    const navigate = useNavigate();

    const refreshPage = () => {
        resetError && resetError();
        navigate("/");
    }

    return (
        <div className="flex-1 flex flex-row text-center items-center pb-16 select-none mx-auto max-w-[674px]">
            <div className="flex-1 flex flex-col gap-3 items-center">
                <div className="flex flex-row items-end">
                    <span className="font-bold text-[80px] md:text-[200px] inline-block">4</span>
                    <ZeroImg className="h-[80px] md:h-[200px] mb-10" />
                    <span className="font-bold text-[80px] sm:text-[200px] inline-block">4</span>
                </div>

                <h1 className="font-bold text-xl md:text-[46px] md:leading-[60px] tracking-[-0.08em]">
                    Ah, dang. We didn't find that page.
                </h1>
                <p className="text-gray-700 text-lg mb-6">
                    The page you’re looking for doesn’t exist or may have been moved.
                </p>

                <div>
                    <button onClick={refreshPage} className="bg-brand-500 text-sm text-white px-6 py-2.5 rounded-2xl">
                        Return to Homepage
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;